import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-cream pt-12 pb-16 md:pt-20 md:pb-24 px-4 overflow-hidden" data-id="element-43">
      <div className="max-w-5xl mx-auto" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-45">
          <div className="inline-block bg-amber/20 text-navy font-semibold px-4 py-2 rounded-full mb-6 text-sm md:text-base" data-id="element-46">
            Consigue "El Protocolo de Conexión de 7 Días" por solo $14.97.
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-navy font-bold leading-tight mb-6" data-id="element-47">
            Cómo recuperar la conexión con tu hijo adolescente{' '}
            <span className="text-amber italic" data-id="element-48">
              (aunque hoy solo recibas silencios y portazos)
            </span>
          </h1>

          <p className="font-body text-lg md:text-xl text-charcoal max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-49">
            El Protocolo de 7 Días para derribar el muro de la depresión en casa
            sin interrogatorios, sin sermones y sin peleas.
          </p>

          <CTAButton className="mb-12" data-id="element-50" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative max-w-4xl mx-auto" data-id="element-51">
          <div className="absolute inset-0 bg-amber/10 rounded-3xl transform rotate-2 scale-105 -z-10" data-id="element-52"></div>
          <img src="https://cdn.magicpatterns.com/uploads/anZf1zew5c87CwH8gGBFaV/El_Protocolo_de_conexion_de_7_dias.png" alt="El Protocolo de Conexión de 7 Días en una laptop" className="w-full h-auto rounded-2xl shadow-2xl transform -rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-53" />
        </motion.div>
      </div>
    </section>;
}